// extracted by mini-css-extract-plugin
export default {"container":"ReportDashboard_container__2N2UW","description":"ReportDashboard_description__GtZO1","noData":"ReportDashboard_noData__TfKJ+"};